import { Toaster as Sonner } from "sonner";

export function Toaster() {
  return (
    <Sonner
      theme="dark"
      position="bottom-right"
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "!rounded-xl !border !border-gold-400/25 !bg-obsidian-950/90 !backdrop-blur-xl !shadow-glass !font-body",
          title: "!font-display !tracking-wide",
          description: "!text-muted-foreground",
        },
      }}
    />
  );
}
